import { Group, HoverCard, Text } from '@mantine/core'

export interface DataGridListProps {
  title: string
  data: string[]
}

export const DataGridList = (props: DataGridListProps) => {
  const { data } = props

  return (
    <HoverCard position="top" shadow="md">
      <HoverCard.Target>
        <Text size="sm" style={{ cursor: 'pointer' }}>
          {data[0]}... {data.length > 2 && <>+{data.length - 1}</>}
        </Text>
      </HoverCard.Target>
      <HoverCard.Dropdown maw={400}>
        <Group>
          <Text size="sm">{data.join(', ')}.</Text>
        </Group>
      </HoverCard.Dropdown>
    </HoverCard>
  )
}
